import { createSlice } from "@reduxjs/toolkit";
import { login } from "../authVerification/authThunk";
import { startExamActivity, submitExam } from "../../activityAsyncAction";

const initialState = {
  details: null,
  activity: null,
  examPlan: "basic",
  submitted: false,
  submissionError: false,
  submissionLoading: false,
  showFeedBack: false,
};

export const examDetailSlice = createSlice({
  name: "examDetail",
  initialState,
  reducers: {
    closeFeedBack: (state) => {
      state.showFeedBack = false;
    },
    openFeedBack: (state) => {
      state.showFeedBack = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.fulfilled, (state, action) => {
      const { data } = action.payload;
      console.log(action.payload);
      state.details = data?.exam;
      state.examPlan = data?.exam?.plan;
    });
    builder.addCase(startExamActivity.fulfilled, (state, action) => {
      state.loading = false;
      const {
        data: { examActivity },
      } = action.payload;

      state.activity = examActivity;
    });

    builder.addCase(submitExam.fulfilled, (state, action) => {
      state.submissionError = true;
      state.submissionLoading = false;
      state.submitted = true;
    });

    builder.addCase(submitExam.pending, (state, action) => {
      state.submissionLoading = true;
      state.submissionError = false;
    });
    builder.addCase(submitExam.rejected, (state, action) => {
      state.submissionError = true;
      state.submissionLoading = false;
    });
  },
});

export const { closeFeedBack, openFeedBack } = examDetailSlice.actions;

export default examDetailSlice.reducer;
